<template>
  <label
    class="mosta-checkbox"
    :class="{
      'mosta-checkbox--disabled': disable,
      'mosta-checkbox--checked': isChecked,
    }"
    @click.prevent="toggle"
  >
    <svg class="mosta-checkbox__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect class="mosta-checkbox__box" x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="white" />
      <path
        v-if="isChecked"
        class="mosta-checkbox__check"
        d="M13 5L6.125 12L3 8.81818"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span v-if="label" class="mosta-checkbox__label">{{ label }}</span>
    <slot />
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  modelValue?: any;
  label?: string;
  disable?: boolean;
  trueValue?: any;
  falseValue?: any;
  toggleIndeterminate?: boolean;
  indeterminateValue?: any;
}>(), {
  modelValue: false,
  disable: false,
  trueValue: true,
  falseValue: false,
  toggleIndeterminate: false,
  indeterminateValue: null,
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: any): void;
}>();

const isChecked = computed(() => props.modelValue === props.trueValue);

const isIndeterminate = computed(() =>
  props.toggleIndeterminate && props.modelValue === props.indeterminateValue
);

function toggle() {
  if (props.disable) return;

  if (props.toggleIndeterminate) {
    if (props.modelValue === props.falseValue) {
      emitValue(props.indeterminateValue);
    } else if (props.modelValue === props.indeterminateValue) {
      emitValue(props.trueValue);
    } else {
      emitValue(props.falseValue);
    }
  } else {
    emitValue(isChecked.value ? props.falseValue : props.trueValue);
  }
}

function emitValue(val: any) {
  emit('update:modelValue', val);
}
</script>

<style lang="scss" scoped>
.mosta-checkbox {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;

  &--disabled {
    opacity: 1;
    pointer-events: none;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__box {
    fill: #fff;
    stroke: var(--checkbox-border-color, #D2D2D2);
  }

  &__check {
    stroke: var(--checkbox-active-color, #3F884F);
  }

  &--checked &__box {
    stroke: var(--checkbox-active-color, #3F884F);
  }

  &__label {
    line-height: 1.286;
  }
}

.mosta-checkbox:not(.mosta-checkbox--disabled):hover .mosta-checkbox__box {
  fill: #F2F2F2;
}

.mosta-checkbox--disabled .mosta-checkbox__box {
  fill: #fff;
  stroke: #F2F2F2;
}

.mosta-checkbox--disabled.mosta-checkbox--checked .mosta-checkbox__box {
  stroke: #AEC9B4;
}

.mosta-checkbox--disabled.mosta-checkbox--checked .mosta-checkbox__check {
  stroke: #AEC9B4;
}
</style>
